import { render, staticRenderFns } from "./constructionInfo.vue?vue&type=template&id=3aa1f79a&"
import script from "./constructionInfo.vue?vue&type=script&lang=js&"
export * from "./constructionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports